<lib-chart-line disableLegend [chartConf]="conf"/>